import { EventEmitter } from 'events';

import Api from '../services/schedulerapi';
import * as moment from 'moment';
import { resolve } from 'url';

class Schedules extends EventEmitter {
    constructor() {
        super();
        this.prefix = 'SCHEDULE_STORE_';
    }

    fetchCreateEventDefaults = () => {
        return {
            focused: false, //needed for datepicker
            startDate: null,
            endDate: null,
            eventType: "",
            startTime: "",
            seats: 0,
            reccurence: "",
            days: [],
        }
    }

    updateActiveView = (e) => {
        //console.log("update Active View");
        this.activeView = e.view;
    }

    fetchData = (start) => {
        var d = new moment(start);
        let startMonth = d.clone().startOf('month').format("YYYY-MM-DD");
        let endMonth = d.clone().endOf('month').format("YYYY-MM-DD");
        var date = {
            start: startMonth,
            end: endMonth
        }
        Api.getMonthlySlots(date).then((r) => {
            //console.log(r);
            this.emitResults(r, 'fetchData');
        });
    }

    createEvent = (payload) => {
        try {
            payload.eventStart = payload.eventStart.format('YYYY-MM-DD');
            payload.eventEnd = payload.eventEnd.format('YYYY-MM-DD');
            payload.recurrence = payload.recurrence.toLowerCase().replace('-', '');
            payload.eventTime = payload.eventTime + ':00';
            //console.log('before submit ',payload);
            Api.createEventSlot(payload).then((r) => {
                if (r.status == 200) {
                    this.emitResults(r, 'createEvent');
                }
                else if (r.status === 500 || r.status === 404) {
                    this.emitResults(true, 'warningEvent');
                }
                else {
                    this.emitError({ message: 'Event slot could not be created, please contact support.' });
                }
            });
        }
        catch (e) {
            this.emitError({ message: 'Incomplete or Invalid data present' });
        }
    }

    fetchPassengers = (event) => {
        var d = new moment(event.start).format("YYYY-MM-DD");
 
        Api.getPassengersOnDate(d).then((r) => {
            if (this.activeView == 'day' && event.resource._id) {
                r.data = r.data.filter((item) => item._id === event.resource._id)
            }
            var isBlackout= r.data[0] ? r.data[0].isBlackedOut :false;
            var payload ={
                date: d,
                blackOut: isBlackout
            }
            this.emitResults(r, 'fetchPassengers');
            this.emitDate(payload, 'fetchReserveDate');
            //this.emitDate(d, 'fetchReserveDate');
        });
    }

    fetchTodayReservation = () => {
        var d = new moment(new Date()).format("YYYY-MM-DD")
        Api.getPassengersOnDate(d).then((r) => {
            r.data = r.data.filter(x=>x.reservations.length > 0);
            this.emitBlackoutResult(r, 'todayReservationEvent');
        });
    }

    blackOutSlots = (payload) => {
        //var d = new moment(event.start).format("YYYY-MM-DD");
        var blackout = payload.isBlackedOut;

        Api.blackoutSlot(payload).then((r) => {
            if(r.status === 200)
            {
                console.log(r);
                this.emitDate(blackout, 'blackOutEvent');
            }
        }).catch((ex) => {
            console.log(ex);
        });
    }

    fetchReservation = (event) => {
        //var d = new moment(event.start).format("YYYY-MM-DD");

        Api.getPassengersOnDate(event.date).then((r) => {
            if (event.id) {
                r.data = r.data.filter((item) => item._id === event.id)
            }
            var isBlackout= r.data[0] ? r.data[0].isBlackedOut :false;

            var payload ={
                date: event.date,
                blackOut: isBlackout
            }
            this.emitResults(r, 'fetchPassengers');
            this.emitDate(payload, 'fetchReserveDate');
            // this.emitDate(event.date, 'fetchReserveDate');
        });
    }

    postPassangerEvent = (event) => {
        var show = true;
        this.emitDate(show, 'showReservation');
    }

    closeReservation = (event) => {
        this.fetchData(new Date());
        this.emitDate(false, 'closeReservationEvent');
    }

    emitError = (err) => {
        var payload = { ...err };
        this.emit('ERROR', payload);
    }

    getEventPrefix = (func) => {
        return `${this.prefix}${func}`;
    }

    emitResults = (r, func) => {
        if (!r.data) {
            //console.log(r);
            this.emitError({ alert: true, message: 'No Slots found' });
        }
        this.setMaxListeners(1000);
        this.emit(`${this.prefix}${func}`, r.data);
    }

    emitBlackoutResult = (r, func) => {
        this.setMaxListeners(1000);
        this.emit(`${this.prefix}${func}`, r.data);
    }

    emitDate = (r, func) => {
        this.setMaxListeners(1000);
        this.emit(`${this.prefix}${func}`, r);
    }

    debug = (r) => {
        //console.log(r.data);
    }
}

const tandemData = new Schedules();
window.tandemData = tandemData;
export default tandemData;